export default __webpack_public_path__ + "static/media/srg.49dd39bf.svg";